export const environment = {
  production: false,
  keplerUrl: 'https://titan.dev-keplerbe.kairhos.com/v1',
  rubinUrl:  'https://titan.dev-keplerbe.kairhos.com/v1',
  authTokenKey: 'access',
};
